module.exports = __webpack_public_path__ + "static/media/bagy17.d0856773.png";